import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';
import { CustomCodeService } from '../custom-code.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})

export class AuthenticationComponent implements OnInit {
  
  isChecked: boolean = true;
  selectedCustomCode = '';
  constructor(private router: Router, private _location: Location, private customCodeService: CustomCodeService, private activatedRoute: ActivatedRoute,) { }
  toggle() {
    this.isChecked = !this.isChecked;
  }

  backClicked() {
    this.router.navigate([`/custom-code/edit/${this.selectedCustomCode}`]);
  }
  isConfirmButtonEnabled: boolean = false;

  enableConfirmButton(checked: boolean){
    this.isConfirmButtonEnabled = checked;
  }
  ngOnInit(): void {
    this.selectedCustomCode = this.activatedRoute.snapshot.params.customCode;
  }

  confirmButtonClick() {
    const radioButton1 = document.querySelector('input[name="myRadio"][value="option1"]') as HTMLInputElement;
    const radioButton2 = document.querySelector('input[name="myRadio"][value="option2"]') as HTMLInputElement;

    if (radioButton1 && radioButton1.checked) {
        this.router.navigate([`/custom-code/authentication-native/${this.selectedCustomCode}`]);
    } else if (radioButton2 && radioButton2.checked) {
        this.router.navigate([`/custom-code/auth-url/${this.selectedCustomCode}`]);
    }
  }
}
